import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Categorias } from 'src/app/interfaces/categorias';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { Ciudad, Estado } from 'src/app/interfaces/ubicaciones';
import { VacanteDTO } from 'src/app/interfaces/vacantes';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { UbicacionService } from 'src/app/services/ubicacion/ubicacion.service';
import { VacantesService } from 'src/app/services/vacante/vacantes.service';
import { environment } from 'src/environments/environment';
import { ModalMessageComponent } from '../../common/modalmessage/modalmessage.component';
import { Countries } from "src/app/shared/country-data-store";
import { RolesType } from 'src/app/enums/RolesType.enum';
import { Router } from '@angular/router';
import { ModalidadEmpleo } from 'src/app/interfaces/modalidad';
import intlTelInput from 'intl-tel-input';

const correoRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-post-a-job',
  templateUrl: './post-a-job.component.html',
  styleUrls: ['./post-a-job.component.scss']
})
export class PostAJobComponent implements OnInit {
  // @ViewChild('telefonoInput') telefonoInput: ElementRef;
  usuario: JwtResponse;
  vacante: VacanteDTO;
  idVacante: number;
  formVac: FormGroup;
  estados: Estado[];
  ciudades: Ciudad[];
  categorias: Categorias[];
  modalidades: ModalidadEmpleo[];
  paises: any;
  paisCodigo1: number;
  paisCodigo2: number;
  seleccionoEstado: boolean;
  enviandoVacante: boolean;
  telefono: string;
  telefonoAlt: string;
  pais: string;
  // telefonoInput: any
  telefonoInputAlt: any

  constructor(private title: Title, private meta: Meta, private formBuilder: FormBuilder, private modalService: NgbModal,
  private vancanteService: VacantesService, private ubicacionService: UbicacionService,
  private inicioService: InicioService, private router: Router) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this. agregarMetaData();
    this.cargarEstados();
    this.obtenerCategorias();
    this.cargarModalidades();
    this.paises = Countries;
    this.vacante = {} as VacanteDTO;
    this.paisCodigo1 = 52;
    this.paisCodigo2 = 52;
    this.seleccionoEstado = false;
    this.enviandoVacante = false;
    this.telefono = null;
    this.telefonoAlt = null;
    this.pais = null;
  }

  ngOnInit(): void {
    this.crearFormularioVacante();
    if(localStorage.getItem('idVacante')){
      this.idVacante = JSON.parse(localStorage.getItem('idVacante'));
      this.obtenerVacante(this.idVacante);
    }
  }

  private agregarMetaData(): void {
    this.title.setTitle('Postular Vacante');
    this.meta.updateTag({name: "description", content: "Crea y edita tus vacantes para que el mejor talento se postule."});//falta descripcion e imagen para mostrar en open graph
    this.meta.updateTag({name: "keywords", content: "registro, empresas, postulaciones, cuenta, vacantes"});
    this.meta.updateTag({name: "robots", content: "noodp"});
    this.meta.updateTag({property: "og:title", content: "Postular Vacante"});
    this.meta.updateTag({property: "og:description", content: "Crea y edita tus vacantes para que el mejor talento se postule."});
    this.meta.updateTag({property: "og:url", content: environment.baseTG});
    this.meta.updateTag({property: "og:site_name", content: "TG Empleos"});
    this.meta.updateTag({property: "og:locale", content: "es_ES"});
    this.meta.updateTag({property: "og:type", content: "website"});
    this.meta.updateTag({property: "og:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:title", content: "Postular Vacante"});
    this.meta.updateTag({name: "twitter:description", content:"Crea y edita tus vacantes para que el mejor talento se postule."});
    this.meta.updateTag({name: "twitter:site", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:image", content: environment.baseAssets+"/img/sitio-web-de-tg.jpg"});
    this.meta.updateTag({name: "twitter:creator", content: "@tecgurusnet"});
    this.meta.updateTag({name: "twitter:card", content: "summary"});
  }

  crearFormularioVacante(): void {
    this.formVac = this.formBuilder.group({
      nombre: [this.vacante.nombre, Validators.required],
      numVacantes: [this.vacante.numVacantes, [Validators.pattern(/^([0-9])*$/), Validators.maxLength(3), Validators.required]],
      descripcion: [this.vacante.descripcion, Validators.required],
      visible: [this.vacante.status, Validators.required],
      experiencia: [this.vacante.experiencia, [Validators.maxLength(255), Validators.required]],
      escolaridad: [this.vacante.escolaridad, [Validators.maxLength(255), Validators.required]],
      conocimiento: [this.vacante.conocimientos, Validators.maxLength(255)],
      habilidad: [this.vacante.habilidades, Validators.maxLength(255)],
      actividad: [this.vacante.actividades, Validators.maxLength(255)],
      edad: [this.vacante.edad, [Validators.pattern(/^([0-9 -])*$/)]],
      idioma: [this.vacante.idiomas, Validators.maxLength(20)],
      genero: [this.vacante.sexo],
      mudar: [this.vacante.mudar],
      viajar: [this.vacante.viajar],
      categoria: [this.vacante.idCategoria, Validators.required],
      tipoContrato: [this.vacante.tipoContrato, Validators.required],
      especificarContrato: [this.vacante.tiempoContrato, Validators.required],
      modalidadEmpleo: [this.vacante.idModalidadEmpleo, Validators.required],
      pais: [this.vacante.pais, Validators.required],
      estado: [this.vacante.idEstado],
      ciudad: [this.vacante.idCiudad],
      direccion: [this.vacante.direccion, Validators.maxLength(255)],
      salarioMin: [this.vacante.salarioMin, Validators.maxLength(10)],
      salarioMax: [this.vacante.salarioMax, Validators.maxLength(10)],
      nombreContacto: [this.vacante.nombreContacto],
      aPaterno: [this.vacante.appaternoContacto],
      aMaterno: [this.vacante.apmaternoContacto],
      cargo: [this.vacante.cargoContacto],
      correo: [this.vacante.correoContacto, Validators.pattern(correoRegExp)],
      telefono: [this.telefono, [Validators.pattern(/^([0-9])*$/), Validators.minLength(8), Validators.maxLength(12)]],
      telefonoAlt: [this.telefonoAlt, [Validators.pattern(/^([0-9])*$/), Validators.minLength(8), Validators.maxLength(12)]]
    });
  }

  async obtenerVacante(idVacante: number){
    try {
      const response = await this.vancanteService.obtenerDetallesVacante(idVacante, null);
      this.vacante = response.data;
      if(this.vacante){
        this.modificarTelefono(this.vacante.telefono1Contacto, this.vacante.telefono2Contacto)
        this.crearFormularioVacante();
        this.cargarCiudadesPorEstado(this.formVac.get('estado').value);
        this.seleccionarIdModalidadEmpleo();
        this.pais = this.formVac.value.pais;
          // Llama a onCountryChanged manualmente
      this.onCountryChanged(this.paisCodigo1.toString(), false);
      this.onCountryChanged(this.paisCodigo2.toString(), true);
      }
    } catch (error) {
      console.error("Error en obtener la vacante", error);
    }
  }

  async obtenerCategorias(){
    try {
      const response = await this.inicioService.obtenerCategoriasEmpresas();
      this.categorias = response.data;
    } catch (error) {
      console.error("Error al obtener las categorías", error);
    }
  }

  seleccionarPais(pais: string): void {
    this.pais = pais;
    if(this.pais != "México"){
        this.formVac.get("estado").setValue(null);
        this.formVac.get("ciudad").setValue(null);
    }
  }

  async cargarEstados(){
    try {
      const response = await this.ubicacionService.obtenerEstados();
      this.estados = response.data;
    } catch (error) {
      console.error("Error en cargar los estados", error);
    }
  }

  seleccionarEstado() {
    if(this.formVac.get('estado').value){
      this.formVac.get("ciudad").setValue(null);

      this.cargarCiudadesPorEstado(this.formVac.get('estado').value);
      this.seleccionoEstado = true;
    }
  }

  seleccionarIdModalidadEmpleo() {
    for (const modalidad in this.modalidades) {
        if (Object.prototype.hasOwnProperty.call(this.modalidades, modalidad)) {
            const element = this.modalidades[modalidad];
            if(element.nombre === this.vacante.modalidadEmpleo){
                this.formVac.get("modalidadEmpleo").setValue(element.idmodalidadempleo)
            }
        }
    }
  }

  ocultarMensaje(): void {
    this.seleccionoEstado = false;
  }

  async cargarCiudadesPorEstado(idEstado: number) {
    try {
      const response = await this.ubicacionService.obtenerCiudadesPorEstado(idEstado);
      this.ciudades = response.data;
    } catch (error) {
      console.error("Error en cargar los estados", error);
    }
  }

  async cargarModalidades() {
    try {
      const response = await this.vancanteService.obtenerModalidadesEmpleo();
      this.modalidades = response.data;
    } catch (error) {
      console.error("Error en cargar las modalidades empleo.", error);
    }
  }

  obtenerCodigoTelefono1(event: any): void{
    this.paisCodigo1 = parseInt(this.generarSplitTelefono(event.dialCode, "+", false));
  }

  obtenerCodigoTelefono2(event: any): void{
    this.paisCodigo2 = parseInt(this.generarSplitTelefono(event.dialCode, "+", false));
  }

  private modificarTelefono(telefono: string, telefonoAlt: string){
    this.telefono = this.generarSplitTelefono(telefono, ")", false);
    const lada = this.generarSplitTelefono(telefono, this.telefono, true);
    if(lada != ""){
      this.paisCodigo1 = parseInt(lada.slice(2, -1));
      console.log(this.paisCodigo1);
    }
  
    this.telefonoAlt = this.generarSplitTelefono(telefonoAlt, ")", false);
    const ladaAlt = this.generarSplitTelefono(telefonoAlt, this.telefonoAlt, true);
    if(ladaAlt != ""){
      this.paisCodigo2 = parseInt(ladaAlt.slice(2, -1));
      console.log(this.paisCodigo2);
    }
  }
  

  private generarSplitTelefono(telefono: string, valorSplit:string, regresaLada: boolean): string{
    if(telefono){
        const telefonoSplit = telefono.split(valorSplit);
        console.log("telefono: ",telefonoSplit)
        if(telefonoSplit.length == 1 || regresaLada){
            return telefonoSplit[0];
        }else if(telefonoSplit.length == 2){
            return telefonoSplit[1];
        }
    }
    return "";
  }

  codigoPaisTelefono: string;
  codigoPaisTelefonoAlt: string;

  onCountryChanged(event: string, isTelefonoAlt: boolean): void {
    console.log('event', event)
    if (isTelefonoAlt) {
      this.codigoPaisTelefonoAlt = event;
    } else {
      this.codigoPaisTelefono = event;
    }
  }

  validarVacante(){
    
    if(this.usuario.role === RolesType.EMPRESAS){
      const vacante: VacanteDTO = {
        idVacante: this.idVacante? this.idVacante : null,
        idEmpresa: null,
        nombre: this.formVac.get('nombre').value ,
        descripcion: this.formVac.get('descripcion').value ,
        experiencia: this.formVac.get('experiencia').value ,
        conocimientos: this.formVac.get('conocimiento').value ,
        habilidades: this.formVac.get('habilidad').value ,
        actividades: this.formVac.get('actividad').value ,
        escolaridad: this.formVac.get('escolaridad').value ,
        sexo: this.formVac.get('genero').value ,
        edad: this.formVac.get('edad').value ,
        idiomas: this.formVac.get('idioma').value ,
        viajar: this.formVac.get('viajar').value ,
        mudar: this.formVac.get('mudar').value ,
        tipoContrato: this.formVac.get('tipoContrato').value ,
        tiempoContrato: this.formVac.get('especificarContrato').value ,
        idCategoria: this.formVac.get('categoria').value ,
        salarioMin: this.formVac.get('salarioMin').value ,
        pais: this.formVac.get('pais').value ,
        idEstado: this.formVac.get('estado').value ,
        idCiudad: this.formVac.get('ciudad').value ,
        direccion: this.formVac.get('direccion').value ,
        nombreContacto: this.formVac.get('nombreContacto').value ,
        appaternoContacto: this.formVac.get('aPaterno').value ,
        apmaternoContacto: this.formVac.get('aMaterno').value ,
        cargoContacto: this.formVac.get('cargo').value ,
        telefono1Contacto: (this.formVac.get('telefono').value ? ('(+' + this.codigoPaisTelefono + ')' + this.formVac.get('telefono').value) : this.vacante.telefono1Contacto),
        telefono2Contacto: (this.formVac.get('telefonoAlt').value ? ('(+' + this.codigoPaisTelefonoAlt + ')' + this.formVac.get('telefonoAlt').value) : this.vacante.telefono2Contacto),
        correoContacto: this.formVac.get('correo').value ,
        salarioMax: this.formVac.get('salarioMax').value ,
        status: this.formVac.get('visible').value ,
        numVacantes: this.formVac.get('numVacantes').value ,
        idModalidadEmpleo: this.formVac.get('modalidadEmpleo').value ,
        modalidadEmpleo: null,
        urlVacante:null
      };
      console.log('vacante', vacante)
    //  
    if(this.idVacante){
      this.actualizarVacante(vacante)
    }else{
      this.registrarVacante(vacante)
    }
    }
    
  }

  registrarVacante(vacante: VacanteDTO): void {
    this.enviandoVacante = true;
    this.vancanteService.crearVacanteEmpresa(this.usuario.user.idUsuario, vacante).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", "Disculpe las molestias ha ocurrido un error favor de volver a intentarlo más tarde.");
        this.enviandoVacante = false;
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.abrirModalMessage("Éxito", "Se ha registrado correctamente la vacante.");
        this.redirigirVacantes();
      } else {
        this.abrirModalMessage("Error", "No se ha registrado correctamente " + result.messageError);
        console.error('Error al registrar la postulación del vacante de la empresa: ', result.messageError);
      }
      this.enviandoVacante = false;
    });
  }

  actualizarVacante(vacante: VacanteDTO){
    this.enviandoVacante = true;
    this.vancanteService.actulizarVacanteEmpresa(vacante).pipe(
      catchError(error => {
        let mensajeError = '';
        if (error.status === 0) {
          mensajeError = 'Error: se ha producido un error: ' + error.error + '\n';
          mensajeError += `Http error: ${error.message}`;
          console.error('se ha producido un error:', error.error);
        } else {
          mensajeError = `Error (código ${error.error.statusCode}): mensaje de error: ${error.error.message}.\n`;
          mensajeError += `Http error: ${error.message}`;
          console.error(`Error en el API ${error.status}, cuerpo: `, error.error);
        }
        this.abrirModalMessage("Error", "Disculpe las molestias ha ocurrido un error favor de volver a intentarlo más tarde.");
        this.enviandoVacante = false;
        return throwError(mensajeError);
      })
    ).subscribe(result => {
      if (result.success) {
        this.ngOnInit();
        this.abrirModalMessage("Éxito", "Se ha actualizado correctamente la vacante.");
        this.redirigirVacantes();
      } else {
        this.abrirModalMessage("Error", "No se ha actualizado correctamente " + result.messageError);
        console.error('Error al actualizar la postulación del vacante de la empresa: ', result.messageError);
      }
      this.enviandoVacante = false;
    });
  }

  abrirModalMessage(modalTitle: string, modalMessage: string) {
    const modalRef = this.modalService.open(ModalMessageComponent, { centered: true });
    modalRef.componentInstance.modalTitle = modalTitle;
    modalRef.componentInstance.modalMessage = modalMessage;
  }

  redirigirVacantes(){
    setTimeout(() => {
      this.router.navigate(['/vacantes']);
  }, 2000);
  }

  mostrarMensajeErrorModal(){
    if(!this.formVac.get('nombre').value){
        this.abrirModalMessage("Alerta", "Escribe el nombre de la vacante.");
        return;
    }
    if(!this.formVac.get('numVacantes').value){
        this.abrirModalMessage("Alerta", "Escribe el número de vacantes.");
        return;
    }
    if(!this.formVac.get('descripcion').value){
        this.abrirModalMessage("Alerta", "Escribe una descripción sobre la vacante.");
        return;
    }
    if(this.formVac.get('visible').value == undefined || !this.formVac.get('visible').value == null){
        this.abrirModalMessage("Alerta", "Favor de seleccionar si es visible.");
        return;
    }
    if(!this.formVac.get('experiencia').value){
        this.abrirModalMessage("Alerta", "Escribe la experiencia necesaria para la vacante.");
        return;
    }
    if(!this.formVac.get('escolaridad').value){
        this.abrirModalMessage("Alerta", "Escribe la escolaridad necesaria para la vacante.");
        return;
    }
    if(!this.formVac.get('categoria').value){
        this.abrirModalMessage("Alerta", "Seleccione la categoría para la vacante.");
        return;
      }
    if(!this.formVac.get('tipoContrato').value){
        this.abrirModalMessage("Alerta", "Seleccione el tipo de contrato para la vacante.");
        return;
    }
    if(!this.formVac.get('especificarContrato').value){
        this.abrirModalMessage("Alerta", "Específique el tiempo de contratación de la vacante.");
        return;
    }
    if(!this.formVac.get('modalidadEmpleo').value){
        this.abrirModalMessage("Alerta", "Seleccione modalidad para la vacante.");
        return;
    }
    if(this.pais == "Seleccione un País" || this.pais == null){
        this.abrirModalMessage("Alerta", "Seleccione el país.");
        return;
    }
  }

  validarUbicaciones(){
    if(this.pais == "Seleccione un País" || this.pais == null){
        this.abrirModalMessage("Alerta", "Seleccione el país.");
        return false;
    }
    if((!this.formVac.get('estado').value || this.formVac.get('estado').value == 0)
        && this.pais == 'México'){
        this.abrirModalMessage("Alerta", "Seleccione el Estado.");
        return false;
    }
    if((!this.formVac.get('ciudad').value || this.formVac.get('ciudad').value == 0)
        && this.pais == 'México'){
        this.abrirModalMessage("Alerta", "Seleccione "+(this.formVac.get('estado').value == 9 ?
        "una Alcaldía.":"un Municipio."));
        return false;
    }

    return true;
  }
}
